import { SearchField } from "./SearchField.jsx";
import { useThemeSlice } from "./StatusBadge.jsx";
import { EntityTableBodySkeleton } from "../skeletons/EntityTableBodySkeleton.jsx";

export function EntityPageHeader({ title, subtitle, count }) {
  const { c } = useThemeSlice();
  return (
    <div style={{ padding: "18px 20px 12px", borderBottom: `1px solid ${c.divider}`, flexShrink: 0 }}>
      <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: c.text }}>{title}</h1>
      <p style={{ margin: "4px 0 0", fontSize: 12, color: c.sub }}>
        {subtitle}{count != null ? ` · ${count} total` : ""}
      </p>
    </div>
  );
}

export function EntityToolbar({ search, onSearchChange, placeholder = "Search…" }) {
  const { c } = useThemeSlice();
  return (
    <div style={{ padding: "12px 20px", borderBottom: `1px solid ${c.divider}`, display: "flex", gap: 10, flexShrink: 0 }}>
      <SearchField value={search} onChange={onSearchChange} placeholder={placeholder} variant="entity" wrapperStyle={{ flex: 1, maxWidth: 320 }} />
    </div>
  );
}

export function EntityEmptyState({ message }) {
  const { c } = useThemeSlice();
  return (
    <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: c.sub, fontSize: 13 }}>
      {message}
    </div>
  );
}

export function EntityLoadingState() {
  return <EntityTableBodySkeleton />;
}
